/**
 * SEO utility functions for Pazarlo
 */

const TR_MAP = {
  'ç': 'c', 'Ç': 'c', 'ğ': 'g', 'Ğ': 'g', 'ı': 'i', 'İ': 'i',
  'ö': 'o', 'Ö': 'o', 'ş': 's', 'Ş': 's', 'ü': 'u', 'Ü': 'u',
  'â': 'a', 'Â': 'a', 'î': 'i', 'Î': 'i', 'û': 'u', 'Û': 'u',
};

export function slugify(text) {
  if (!text) return '';
  let slug = text.toLowerCase();
  for (const [tr, en] of Object.entries(TR_MAP)) {
    slug = slug.replaceAll(tr, en);
  }
  return slug
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 120);
}

export function productUrl(product) {
  const brand = slugify(product?.brand || '');
  const oem = slugify(product?.oem_code || '');
  const name = slugify(product?.name || '');
  let slug = [brand, oem, name].filter(Boolean).join('-');
  if (!slug) slug = product?.sku || product?.id || 'unknown';
  if (slug.length > 150) slug = slug.slice(0, 150).replace(/-$/, '');
  return `/urun/${slug}`;
}
